import * as _ from 'lodash'

import {ESRecord} from "../lib/ESRecord";
import {ESDataStore} from "../lib/ESDataStore";
import {ASync} from "./ASync";

class RecordUtils {


  static CopyProperties(dbContext: ESDataStore,
                        sMapperName: string,
                        srcRow: ESRecord,
                        tgtRow: ESRecord,
                        sColumnNames: string[] = [],
                        sColumnNamesSkip: string[] = [],
                        tgtConstants: {[id:string]: any} = {}) {

    if(_.isEmpty(srcRow)) {
      return
    }

    let idAttribute = dbContext.getModelIdFieldName(sMapperName);
    let modelProperties = dbContext.getModelProperties(sMapperName);
    let sCols: string[] = []
    if(!_.isEmpty(sColumnNames)){
      sCols = sColumnNames
    }
    if((_.indexOf(sCols, '*') != -1) || _.isEmpty(sCols)) {
      _.pull(sCols, '*')
      sCols.push.apply(sCols, modelProperties)
      _.pull(sCols, idAttribute)
    }

    let sColsSkip = _.keyBy(sColumnNamesSkip, (o) => { return o })

    _.forEach(sCols, (aColName: string) => {
      if ((!(aColName in tgtConstants)) && (!(aColName in sColsSkip))) {
        (<any>tgtRow)[aColName] = (<any>srcRow)[aColName]
      }
    })

    _.forEach(tgtConstants, (value, key) => {
      (<any>tgtRow)[key] = value
    })

  }

  static CopyRows(dbContext: ESDataStore,
                  sMapperName: string,
                  srcRows: ESRecord[],
                  sColumnNames: string[] = [],
                  sColumnNamesSkip: string[] = [],
                  tgtConstants: {[id:string]: any} = {})
       : Promise<ESRecord[]> {

    if (_.isEmpty(srcRows)) {
      return ASync.resolve([])
    }

    return new Promise<ESRecord[]>((resolve, error) => {

      let returnValue: ESRecord[] = []

      async function copySync() {

        try {
          for (let idx = 0; idx < srcRows.length; idx++) {
            let srcRecord = srcRows[idx]
            let newRecord: ESRecord = <ESRecord> await dbContext.createRecordWithKey(sMapperName)
            RecordUtils.CopyProperties(dbContext, sMapperName, srcRecord, newRecord, sColumnNames, sColumnNamesSkip, tgtConstants)
            returnValue.push(newRecord)
          }

          // Add to Container
          dbContext.add(sMapperName, returnValue)

          resolve(returnValue)

        } catch (err) {
          error(err)
        }
      }
      copySync()

    })


  }

}


export {RecordUtils}